module.exports = __webpack_public_path__ + "img/user-default.a9ce91ce.svg";